import axios from "axios";
import api_config from "@/config";
import i18n from '@/i18n';

const REST_ENDPOINT = api_config.API_ENDPOINT;
const TOKEN_ESKA = api_config.TOKEN_ESKA;
const TOKEN_XSCHOOLPAY = api_config.TOKEN_XSCHOOLPAY;
const TOKEN_ESKA_API_URL = api_config.ESKA_API_URL;
const XPAY_API_URL = api_config.XPAY_API_URL;
const SF_WEB_API_URL = api_config.SF_WEB_API_URL;

export function validateEmptyData() {
    return "can not be null";
}

export function successCreation() {
    return "has been created successfully";
}
// ========================= get system config ======================
export async function getsystem_config(isAuthenticated = false) {
  if (isAuthenticated) {
    const token = localStorage.getItem("authToken");
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
  
  try {
    const res = await axios({
      url: REST_ENDPOINT + "/api/system_config/",
      method: "GET",
    });
    
    console.log(res.data);
    localStorage.setItem("sf_web_url", res.data.sf_web_api_url);
    localStorage.setItem("ip_toolbox_api_url", res.data.ip_toolbox_api_url);
    
 
    console.log("Version serveur:", res.data.app_version, "Version locale:", localStorage.getItem("app_version"));
    
    return {status: res.status, data: res.data};
  } catch (err) {
    console.error("Erreur lors de la récupération des notes :", err);
    throw err;
  }
}

export async function getSchoolConfig(isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.get(`${REST_ENDPOINT}/api/config/`);
        if (res.status !== 200) return null;
        const data = res.data;
        if (!data) return null;
        if (Array.isArray(data)) return data.length ? data[0] : null;
        if (Array.isArray(data.results)) return data.results.length ? data.results[0] : null;
        return Object.keys(data).length ? data : null;
    } catch (err) {
        if (err.response && err.response.status === 404) return null;
        console.error("Caught an error during GET school config:", err);
        throw err;
    }
}


/**
 * Enregistre un paiement partiel sur une tranche.
 *
 * Champs attendus :
 *   payment_id, amount_paid, operator_code, operator_tx_id,
 *   operator_user_id, processed_on
 */
export async function setPartialPayment(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.post(`${REST_ENDPOINT}/api/set_partial_payment`, data);
        if (res.status === 200 || res.status === 201) {
            return { status: res.status, data: res.data };
        }
        return { status: res.status, data: null };
    } catch (err) {
        console.error("Caught an error during POST partial payment:", err);
        throw err;
    }
}

export async function setSfMode(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.patch(`${REST_ENDPOINT}/api/config/${localStorage.getItem("configID")}/`, data);
        if (res.status === 200) {
            return { status: res.status, data: res.data };
        }
        return { status: res.status, data: null };
    } catch (err) {
        console.error("Caught an error during PATCH config mode:", err);
        throw err;
    }
}

export async function transferOwnerInfo (action, phone, code = '', new_user_phone = '', isAuthenticated=true){
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const data = {}
        data['action'] = action;
        data['phone'] = phone;
        data['code'] = code;
        data['new_user_phone'] = new_user_phone;
            
            const response = await axios({
                url: REST_ENDPOINT + "/api/transfer_owner_infos",
                method: "POST",
                data: data,
                headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}
            });
        return {
        status: response.status,
        data: response.data
        };
    } catch (error) {
        console.error(error);
        
        // Retourner l'erreur
        return {
        status: error.response?.status || 500,
        error: error.response?.data?.message || error.message,
        data: error.response?.data || null
        };
    }
}
// ========================= get sychronisation teachers  ======================

export async function getClassroomexamsgrade(isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: REST_ENDPOINT + "/api/exam-grades/",
            method: "GET",
        });

        return {
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        console.error(i18n.global.t('errors.fetch_notes_error'), err);
        throw err;
    }
}


// ========================= get sychronisation teachers  ======================

export async function getClassroomSyncRequests(isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: REST_ENDPOINT + "/api/classroom-sync-requests/",
            method: "GET",
        });

        return {
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        console.error(i18n.global.t('errors.sync_error'), err);
        throw err;
    }
}

// =========================  Get banner  ======================

export async function getbanners(lang) {
    try {
        const response = await axios.get(
            `${localStorage.getItem("sf_web_url")}/api/banners/?lang=${lang}`,
            {
                headers: {
                    Authorization: `Bearer ${TOKEN_XSCHOOLPAY}`,
                    'Accept': 'application/json'
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching banners data:", error);
        throw error;
    }
}

// =========================  sychronisation teachers  ======================

export async function SyncRequests(data, requestId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + `/api/classroom-sync-requests/${requestId}/`,
            method: "patch",

            data: data,
        });

        if (res.status === 200) {
            response.status = res.status;
            response.data = res.data;
        }
        if (res.status === 403) {
            response.data = res.data;
        }
    } catch (err) {
        response.status = err.response.status;
        console.error("Caught an error during synchronisation classroom:", err);
    }
    return response;
}

// ========================= decline  sychronisation teachers  ======================

export async function decline_syncRequests(data, requestId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + `/api/classroom-sync-requests/${requestId}/`,
            method: "patch",
            data: data,
        });

        if (res.status === 200) {
            response.status = res.status;
            response.data = res.data;
        }
        if (res.status === 403) {
            response.data = res.data;
        }
    } catch (err) {
        response.status = err.response.status;
        console.error("Caught an error during synchronisation decline:", err);
    }
    return response;
}

// =========================  get school info  ======================

export async function getSchoolinfo(schoolId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/get_school_info",
            method: "GET",
            params: {
                school_id: schoolId,
            },
        });
        if (res.status === 200) {
            response.status = res.status;
            response.data = res.data;
        }
    } catch (err) {
        response.status = err.response.status;
        console.error(i18n.global.t('errors.fetch_school_info'), err);
    }
    return response;
}

// ========================= Search ======================

export async function Search(name, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/get_student_info",
            method: "GET",
            params: {
                q: name, // Changed from name:name to q:name to match API endpoint
            },
        });

        if (res.status === 200) {
            response.status = res.status;
            response.data = res.data;
        }
    } catch (err) {
        response.status = err.response.status;
        console.error(i18n.global.t('errors.fetch_students_error'), err);
    }
    return response;
}

// ============ get grade code =============================

export async function getGrades(isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/grades",
            method: "GET",
            params: {
                training_type: localStorage.getItem("training_type"),
                education_grade: localStorage.getItem("education_grade"),
                education_system: localStorage.getItem("education_system"),
            },
        });
        if (res.status === 200) {
            response.status = res.status;
            response.data = res.data;
        }
    } catch (err) {
        response.status = err.response.status;
        console.error("Caught an error during GET grades:", err);
    }
    return response;
}

// =============== get speciality ====================

export async function getSpeciality(isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/specialities",
            method: "GET",
            params: {
                training_type: localStorage.getItem("training_type"),
                education_grade: localStorage.getItem("education_grade"),
                education_system: localStorage.getItem("education_system"),
            },
        });
        if (res.status === 200) {
            response.data = res.data;
        }
    } catch (err) {
        response.status = err.response.status;
        console.error("Caught an error during GET specialities:", err);
    }
    return response;
}

//============= create classroom ======================

export async function createClassroom(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/classrooms/",
            method: "POST",
            data: data,
        });
        if (res.status === 201) {
            response.status = res.status;
            response.data = res.data;
        }
        if (res.status === 403) {
            response.data = res.data;
        }
    } catch (err) {
        response.status = err.response.status;
        console.error("Caught an error during creation of classroom:", err);
    }
    return response;
}

//=========== delete classroom ===================

export async function deleteClassroom(classroom_Id, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/classrooms/${classroom_Id}`,
            method: "DELETE",
        });

        if (res.status === 204) {
            return true;
        }
    } catch (err) {
        console.error("Caught an error during DELETE classroom:", err);
        throw err;
    }
}

// ============ update classroom =================

export async function updateClassroom(classroom_Id, updatedData, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};

    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/classrooms/${classroom_Id}`,
            method: "PUT",
            data: updatedData,
        });

        if (res.status === 200) {
            response.status = res.status;
            response.data = res.data;
        }
    } catch (err) {
        response.status = err.response.status;
        console.error("Caught an error during updating classroom:", err);
    }

    return response;
}

// ============= get classroom by id ==============

export async function getClassroomById(classroomsId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.get(
            `${REST_ENDPOINT}/api/classrooms/${classroomsId}`
        );
        if (res.status === 200) {
            return res.data;
        }
    } catch (error) {
        console.error("Caught an error during GET classroom:", error);
        throw MediaError;
    }
}

// ============= Create members ================

export async function createMembers(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/auth/members/",
            method: "POST",
            data: data,
        });
        console.log(res);

        response.status = res.status;
        response.data = res.data;

        return response;
    } catch (err) {
        if (err.response) {
            response.status = err.response.status;
            response.error = err.response.data;
            console.error("Caught an error during creation of account:", err);
        } else if (err.request) {
            console.error("Network error during creation of account:", err);
        } else {
            console.error("Unexpected error during creation of account:", err);
        }

        return response;
    }
}

// ============== get members =====================

export async function getMembers(isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const response = await axios.get(`${REST_ENDPOINT}/auth/members`);

        // Initialisation des données avec une structure par défaut
        const memberData = {
            internet: false,
            data: [],
            status: 200,
        };

        if (response.status === 200) {
            memberData.data = response.data;
            memberData.status = response.status;
            memberData.internet = true;
        }

        return memberData;
    } catch (error) {
        // Structure cohérente même en cas d'erreur
        return {
            internet: false,
            status: error.response?.status || 500,
            error: error.response?.data || "Erreur serveur interne",
            data: [],
        };
    }
}

export async function getinfoMembers(username, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.get(`${REST_ENDPOINT}/auth/members/`, {
            params: {username: username},
        });

        if (res.status === 200) {
            return res.data;
        }
    } catch (err) {
        console.error("Caught an error during GET member info:", err);
        throw err;
    }
}

export async function updateMemberInfo(username, updatedData, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.patch(
            `${REST_ENDPOINT}/auth/members/${username}/`,
            updatedData
        );

        if (res.status === 200) {
            return res.data;
        }
    } catch (err) {
        console.error("Caught an error during PATCH member info:", err);
        throw err;
    }
}

// Fonction pour mettre à jour le statut is_active d'un membre

export async function updateMemberStatus(memberId, updatedData, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.patch(
            `${REST_ENDPOINT}/auth/members/${memberId}`,
            updatedData
        );

        if (res.status === 200) {
            return res.data;
        }
    } catch (err) {
        console.error("Caught an error during PATCH member:", err);
        throw err;
    }
}

// ============== delete members =====================

export async function deletemember(membersId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/auth/members/${membersId}`,
            method: "DELETE",
        });

        if (res.status === 204) {
            return true;
        }
    } catch (err) {
        console.error("Caught an error during DELETE member:", err);
        throw err;
    }
}

// ============== check alert subscribers =====================

export async function getAlertSubscribers(grades, number, service, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const response = await axios.get(
            `${REST_ENDPOINT}/api/check_alert_subscribers`,
            {
                params: {
                    grades,
                    number,
                    service,
                },
            }
        );

        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        return {
            status: error.response ? error.response.status : 500,
            error: error.response ? error.response.data : "Internal Server Error",
        };
    }
}

//============= Post cleams late transfer ====================
export async function submit_claims_late_transfer(
    title,
    type,
    school_name,
    connection_id,
    id_operation,
    amount,
    start_date,
    end_date,
    isAuthenticated = true
) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const requestData = {
            title: title,
            type: type,
            school_name: school_name,
            connection_id: connection_id,
            data: {
                id_operation: id_operation,
                amount: amount,
                start_date: start_date,
                end_date: end_date,
            },
        };

        const response = await axios({
            url: SF_WEB_API_URL + "/api/claims/",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            data: requestData,
        });

        return response.data;
    } catch (err) {
        console.error(i18n.global.t('errors.claim_submission_error'), err);
        throw err;
    }
}

//============= Post min transfert  transfer  ====================
export async function submit_claims_min_transfer(
    type,
    title,
    school_name,
    connection_id,
    current_amount,
    requested_amount,
    isAuthenticated = true
) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const requestData = {
            type: type,
            title: title,
            school_name: school_name,
            connection_id: connection_id,
            data: {
                current_amount: current_amount,
                requested_amount: requested_amount,
            },
        };

        const response = await axios({
            url: SF_WEB_API_URL + "/api/claims/",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: requestData,
        });

        return response.data;
    } catch (err) {
        console.error(i18n.global.t('errors.claim_submission_error'), err);
        throw err;
    }
}

//============= Post cleams fees and payment ====================
export async function submit_claims_active_fees_payment(
    type,
    title,
    school_name,
    connection_id,
    bear_costs,
    isAuthenticated = true
) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const requestData = {
            type: type,
            title: title,
            school_name: school_name,
            connection_id: connection_id,
            data: {
                bear_costs: bear_costs,
            },
        };

        const response = await axios({
            url: SF_WEB_API_URL + "/api/claims/",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: requestData,
        });

        return response.data;
    } catch (err) {
        console.error(i18n.global.t('errors.claim_submission_error'), err);
        throw err;
    }
}

//============= Post cleams split payment ====================
export async function submit_claims_split_payment(
    type,
    title,
    school_name,
    connection_id,
    split_payment,
    isAuthenticated = true
) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const requestData = {
            type: type,
            title: title,
            school_name: school_name,
            connection_id: connection_id,
            data: {
                split_payment: split_payment,
            },
        };

        const response = await axios({
            url: SF_WEB_API_URL + "/api/claims/",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: requestData,
        });

        return response.data;
    } catch (err) {
        console.error(i18n.global.t('errors.claim_submission_error'), err);
        throw err;
    }
}

//============= Post cleams bank information ====================
export async function submit_claims_bank_information(
    type,
    title,
    school_name,
    connection_id,
    bank_information,
    isAuthenticated = true
) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const requestData = {
            type: type,
            title: title,
            school_name: school_name,
            connection_id: connection_id,
            data: {
                bank_information: bank_information,
            },
        };

        const response = await axios({
            url: SF_WEB_API_URL + "/api/claims/",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: requestData,
        });

        return response.data;
    } catch (err) {
        console.error(i18n.global.t('errors.claim_submission_error'), err);
        throw err;
    }
}

//============= Post cleams incorrect amount ====================
export async function submit_claims_incorrect_amount(
    type,
    title,
    school_name,
    connection_id,
    id_operation,
    Expected_amount,
    current_amount,
    start_date,
    end_date
    , isAuthenticated = true
) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const requestData = {
            type: type,
            title: title,
            school_name: school_name,
            connection_id: connection_id,
            data: {
                id_operation: id_operation,
                expected_amount: Expected_amount,
                current_amount: current_amount,
                start_date: start_date,
                end_date: end_date,
            },
        };

        const response = await axios({
            url: SF_WEB_API_URL + "/api/claims/",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: requestData,
        });

        return response.data;
    } catch (err) {
        console.error(i18n.global.t('errors.claim_submission_error'), err);
        throw err;
    }
}

//============= get cleams  ====================

export async function getCleams(connection_id, type, title, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const response = await axios.get(`${SF_WEB_API_URL}/api/claims/`, {
            params: {
                connection_id,
                type,
                title,
            },
        });

        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        return {
            status: error.response ? error.response.status : 500,
            error: error.response ? error.response.data : "Internal Server Error",
        };
    }
}

//============= upload File ====================

export async function uploadFile(file, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await axios({
            url: REST_ENDPOINT + "/api/upload_file/",
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: formData,
        });

        return response.data;
    } catch (err) {
        console.error("Error while uploading file:", err);
        throw err;
    }
}

/**
 * Upload générique attaché directement à un modèle (ex: le logo d'une
 * `schooling.schoolconfig`). Contrairement à `uploadFile`, qui n'envoie que
 * le fichier, cette fonction transmet aussi `model_name` / `media_field` /
 * `object_id` : c'est ce triplet qui permet au backend de rattacher le
 * fichier au bon enregistrement plutôt que de le stocker sans lien.
 */
export async function uploadFileForModel(
    { file, model_name, media_field, object_id },
    isAuthenticated = true
) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("model_name", model_name);
        formData.append("media_field", media_field);
        formData.append("object_id", object_id);

        const response = await axios({
            url: REST_ENDPOINT + "/api/upload_file/",
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: formData,
        });

        return response.data;
    } catch (err) {
        console.error("Error while uploading model file:", err);
        throw err;
    }
}

export async function uploadbankdoc(fileData, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const formData = new FormData();

        // Ajout des paramètres requis par l'API
        formData.append("file", fileData.selectedFile);

        const response = await axios({
            url: REST_ENDPOINT + "/api/upload_file/",
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: formData,
        });

        return response.data;
    } catch (err) {
        console.error(i18n.global.t('errors.download_file_error'), err);
        throw err;
    }
}

export async function uploadmedia(fileData, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const formData = new FormData();

        formData.append("file", fileData);

        const response = await axios({
            url: REST_ENDPOINT + "/api/upload_file/",
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: formData,
        });

        return response.data;
    } catch (err) {
        console.error(i18n.global.t('errors.download_file_error'), err);
        throw err;
    }
}

//================================= create student ===================

export async function createStudent(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let student = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/student/",
            method: "POST",
            data: data,
        });
        if (res.status === 201) {
            student.status = res.status;
            student.data = res.data;
        }
        if (status.code === 400) {
            student.status = res.status;
            student.data = res.data;
        }
    } catch (err) {
        student = err.response;
        console.error("Caught an error during create student:", err);
    }
    return student;
}

//============= delete students ======================

export async function deleteStudent(studentId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/student/${studentId}`,
            method: "DELETE",
        });

        if (res.status === 204) {
            return true;
        }
    } catch (err) {
        console.error("Caught an error during DELETE students:", err);
        throw err;
    }
}

// ==================update student =================

export async function updateStudent(studentId, updatedData, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.patch(
            `${REST_ENDPOINT}/api/student/${studentId}`,
            updatedData
        );

        if (res.status === 200) {
            return res.data;
        }
    } catch (err) {
        console.error("Caught an error during PATCH students:", err);
        throw err;
    }
}

// ==================get student =================
export async function getStudent(studentId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.get(`${REST_ENDPOINT}/api/student/${studentId}`);

        if (res.status === 200) {
            return res.data;
        }
    } catch (err) {
        console.error("Caught an error during GET student:", err);
        throw err;
    }
}

//============ get student classroom =======================

export async function getStudentClassrooms(params, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/get_classroom_details",
            method: "GET",
            params: params,
        });
        if (res.status === 200) {
            response = res;
        }
    } catch (err) {
        response = err.response;
        console.error("Caught an error during GET student classroom:", err);
    }
    return response;
}

//============ change statut student =======================

export async function statutstudents(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: REST_ENDPOINT + "/api/update_payment_status",
            method: "POST",
            data: data,
        });

        console.log(res);

        return {
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        if (err.response) {
            console.error("Caught an error during creation of installment:", err);
            return {
                status: err.response.status,
                error: err.response.data,
            };
        } else if (err.request) {
            console.error("Network error during creation of installment:", err);
        } else {
            console.error("Unexpected error during creation of installment:", err);
        }

        throw err;
    }
}

//============ change statut student =======================

export async function applyotherpayment(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: REST_ENDPOINT + "/api/create_payment_with_status",
            method: "POST",
            data: data,
        });

        console.log(res);

        return {
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        if (err.response) {
            console.error("Caught an error during creation of installment:", err);
            return {
                status: err.response.status,
                error: err.response.data,
            };
        } else if (err.request) {
            console.error("Network error during creation of installment:", err);
        } else {
            console.error("Unexpected error during creation of installment:", err);
        }

        throw err;
    }
}

//============ batchCreateStudent  =======================

export async function batchCreateStudent(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/batch_create_students/",
            method: "POST",
            data: data,
        });
        if (res.status === 201) {
            response = res;
        }
    } catch (err) {
        response = err.response;
        console.error("Caught an error during GET specialities:", err);
    }
    return response;
}

//============ Create config  =======================

export async function createconfig(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/payments-config/",
            method: "POST",
            data: data,
        });
        console.log(res);

        response.status = res.status;
        response.data = res.data;

        return response;
    } catch (err) {
        if (err.response) {
            response.status = err.response.status;
            response.error = err.response.data;
            console.error("Caught an error during creation of account:", err);
        } else if (err.request) {
            console.error("Network error during creation of account:", err);
        } else {
            console.error("Unexpected error during creation of account:", err);
        }

        return response;
    }
}

//============ update config  =======================

export async function updateConfig(configId, data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + `/api/payments-config/${configId}`,
            method: "PUT",
            data: data,
        });
        console.log(res);

        response.status = res.status;
        response.data = res.data;

        return response;
    } catch (err) {
        if (err.response) {
            response.status = err.response.status;
            response.error = err.response.data;
            console.error("Caught an error during update of configuration:", err);
        } else if (err.request) {
            console.error("Network error during update of configuration:", err);
        } else {
            console.error("Unexpected error during update of configuration:", err);
        }

        return response;
    }
}

//============ get config by id  =======================

export async function getconfig(configtId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.get(
            `${REST_ENDPOINT}/api/payments-config/${configtId}`
        );

        if (res.status === 200) {
            return res.data;
        }
    } catch (err) {
        console.error("Caught an error during GET student:", err);
        throw err;
    }
}

//============ Update school name  =======================

export async function updateSchoolName(configId, newName, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/get_school_info/${configId}/`,
            method: "PATCH",
            data: {
                name: newName,
            },
        });

        if (res.status === 200) {
            return {
                status: res.status,
                data: res.data,
            };
        }
    } catch (err) {
        console.error("Erreur lors de la mise à jour du nom de l'école:", err);
        throw err;
    }
}

//============ get config  =======================

/**
 * Liste les groupes de paiement.
 *
 * `params` est facultatif et suit le contrat de l'API :
 *   { grade_codes: "2ND", speciality_code: "" }
 * Sans paramètre, tous les groupes de l'école sont renvoyés — comportement
 * historique, conservé pour les appels existants.
 */
export async function getcreateconfig(isAuthenticated = true, params = null) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/payments-config/",
            method: "GET",
            params: params || undefined,
        });
        if (res.status === 200) {
            response = res;
        }
    } catch (err) {
        response = err.response;
        console.error("Caught an error during GET student classroom:", err);
    }
    return response;
}

// =========== remove Installment By id ============

export async function removeInstallmentById(installmentId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const response = await axios({
            method: "DELETE",
            url: `${REST_ENDPOINT}/api/payments-config/${installmentId}/`,
        });

        if (response.status === 204) {
            console.log("Installment removed successfully");
        } else {
            console.error("Unexpected status code:", response.status);
        }

        return response;
    } catch (error) {
        console.error("Error during removeInstallmentById:", error);
        throw error;
    }
}

// =============== getCreatConfigdetail ===================

export async function getCreateConfigDetails(payment_config_id, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/payments-config/${payment_config_id}`,
            method: "GET",
        });

        if (res.status === 200) {
            response = res.data;
        }
    } catch (err) {
        response = err.response;
        console.error("Caught an error during GET createconfig details:", err);
    }
    return response;
}

//======================== delete config   =====================

export async function deleteConfig(configId) {
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/payments-config/${configId}`,
            method: "DELETE",
        });

        if (res.status === 204) {
            return true;
        }
    } catch (err) {
        console.error("Caught an error during DELETE configuration:", err);
        throw err;
    }
}

//=============== Submit installment ==================

export async function submitInstallments(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: REST_ENDPOINT + "/api/batch_create_installments/",
            method: "POST",
            data: data,
        });

        console.log(res);

        return {
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        if (err.response) {
            console.error("Caught an error during creation of installment:", err);
            return {
                status: err.response.status,
                error: err.response.data,
            };
        } else if (err.request) {
            console.error("Network error during creation of installment:", err);
        } else {
            console.error("Unexpected error during creation of installment:", err);
        }

        throw err;
    }
}

// ========= Update installment =======================

export async function updateInstallment(installmentId, updatedData, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: REST_ENDPOINT + `/api/payments-installment/${installmentId}/`,
            method: "PUT",
            data: updatedData,
        });

        console.log(res);

        return {
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        if (err.response) {
            console.error("Caught an error during update of installment:", err);
            return {
                status: err.response.status,
                error: err.response.data,
            };
        } else if (err.request) {
            console.error("Network error during update of installment:", err);
        } else {
            console.error("Unexpected error during update of installment:", err);
        }

        throw err;
    }
}

// ======================= get installment =====================

export async function getInstallment(params, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/payments-installment/",
            method: "GET",
            params: params,
        });
        if (res.status === 200) {
            response = res;
        }
    } catch (err) {
        response = err.response;
        console.error("Caught an error during GET student classroom:", err);
    }
    return response;
}

//  ============================ detele installment ====================

export async function deleteInstallment(installmentId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;

    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/payments-installment/${installmentId}`,
            method: "DELETE",
        });

        if (res.status === 200) {
            response = res;
        }
    } catch (err) {
        response = err.response;
        console.error("Caught an error during DELETE installment:", err);
    }

    return response;
}

// ============ get installment Config ================

export async function getinstallmentConfig(params, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/payments-installment/",
            method: "GET",
            params: params,
        });
        if (res.status === 200) {
            response = res;
        }
    } catch (err) {
        response = err.response;
        console.error("Caught an error during GET student classroom:", err);
    }
    return response;
}

// ================== application de la config a une class ===================

export async function applyPaymentConfig(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/classroom-payment-installment/",
            method: "POST",
            data: data,
        });
        console.log(response.data);
        console.log(res);

        response.status = res.status;
        response.data = res.data;

        return response;
    } catch (err) {
        if (err.response) {
            response.status = err.response.status;
            response.error = err.response.data;
            console.error("Caught an error during creation of account:", err);
        } else if (err.request) {
            console.error("Network error during creation of account:", err);
        } else {
            console.error("Unexpected error during creation of account:", err);
        }

        return response;
    }
}

// =========================== get congig ===========================

export async function getclassroomsconfig(isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/classroom-payment-installment/`,
            method: "GET",
        });

        if (res.status === 200) {
            response = res.data;
        }
    } catch (err) {
        response = err.response;
        console.error("Caught an error during GET createconfig details:", err);
    }
    return response;
}

// ==============  get installment classroom config =======================

export async function getInstallmentsForClassroom(classroom_id, isAuthenticated = true) {

    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/classroom-payment-installment/?classroom_id=${classroom_id}`,
            method: "GET",
        });
        if (res.status === 200) {
            response = res.data;
            console.log(response);
        }
    } catch (err) {
        response = err.response;
        console.error("Caught an error during GET createconfig details:", err);
    }
    return response;
}

// ================== application de la config a une class =====================

export async function applyinstallmentstudents(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/batch_create_payments/",
            method: "POST",
            data: data,
        });
        console.log(response.data);
        console.log(res);

        response.status = res.status;
        response.data = res.data;

        return response;
    } catch (err) {
        if (err.response) {
            response.status = err.response.status;
            response.error = err.response.data;
            console.error("Caught an error during creation of account:", err);
        } else if (err.request) {
            console.error("Network error during creation of account:", err);
        } else {
            console.error("Unexpected error during creation of account:", err);
        }

        return response;
    }
}

// ========================= create payments and set status ======================
export async function createAndSetPaymentStatus(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: REST_ENDPOINT + "/api/create_and_set_payment_status",
            method: "POST",
            data: data,
            headers: { 'Content-Type': 'application/json' }
        });

        return {
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        console.error("Caught an error during CREATE_AND_SET_PAYMENT_STATUS:", err);
        return {
            status: err.response?.status || 500,
            error: err.response?.data || err.message,
        };
    }
}

//=========================== send invoice ==========================

export async function sendinvoice(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: REST_ENDPOINT + "/api/send_invoices",
            method: "POST",
            data: data,
        });
        return {
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        if (err.response) {
            console.error("Error sending message:", err);
            return {
                status: err.response.status,
                error: err.response.data,
            };
        }

        if (err.request) {
            console.error("Network error:", err);
        } else {
            console.error("Error:", err);
        }

        throw err;
    }
}

// ============================send invoice ==================

export async function memberinfo(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: REST_ENDPOINT + "/api/send_member_info",
            method: "POST",
            data: data,
        });

        console.log(res);

        return {
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        if (err.response) {
            console.error("Caught an error during creation of installment:", err);
            return {
                status: err.response.status,
                error: err.response.data,
            };
        } else if (err.request) {
            console.error("Network error during creation of installment:", err);
        } else {
            console.error("Unexpected error during creation of installment:", err);
        }

        throw err;
    }
}

// ===================== get dashboard report ========================

export async function getdashboardreport(isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/dashboard_report`,
            method: "GET",
        });

        if (res.status === 200) {
            response = res.data;
            console.log("Réponse de getdashboardreport:", response);
        }
    } catch (err) {
        response = err.response;
        console.error("Erreur lors de l'appel de getdashboardreport:", err);
    }
    return response;
}

// ============== get class detail ============================

export async function getclassroomreport(classroom_id, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    if(classroom_id){
        let response;
        try {
            const res = await axios.get(
                `${REST_ENDPOINT}/api/report?classroom_id=${classroom_id}`
            );
            if (res.status === 200) {
                response = res.data;
            }
        } catch (err) {
            response = err.response;
            console.error("Caught an error during GET report classroom :", err);
        }
        return response;
    }
}

// ========================= get accounting report ======================

/**
 * Rapport d'encaissements.
 *
 * @param {object} params période, voir `reportParams` dans utils/accountingReport :
 *   
 */
export async function getAccountingReport(params = {}, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.get(`${REST_ENDPOINT}/api/accounting_dashboard`, { params });
        return res.data;
    } catch (err) {
        console.error("Caught an error during GET accounting report:", err);
        throw err;
    }
}

// ========================= get financial transaction ======================

export async function getTransactions(xpay_connection_id, starting_on, ending_on, wallet, status, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const response = await axios.get(`${XPAY_API_URL}/api/transactions-log/`, {
            headers: {
                Authorization: `Bearer ${TOKEN_XSCHOOLPAY}`,
            },
            params: {
                xpay_connection_id: xpay_connection_id,
                starting_on: starting_on,
                ending_on: ending_on,
                wallet: wallet,
                status: status,
            },
        });
        return response.data; // Return the data directly
    } catch (error) {
        console.error("Error fetching transaction data:", error);
        throw error; // Re-throw the error to handle it outside this function
    }
}

// ========================= Post claims ======================
export async function submit_claims(type, xpay_connection_id, min_transfer_amount) {
    try {
        const response = await axios.post(`${XPAY_API_URL}/submit-claims/`, null, {
            headers: {
                Authorization: `Bearer ${TOKEN_XSCHOOLPAY}`,
                "Content-Type": "application/json",
            },
            params: {
                xpay_connection_id: xpay_connection_id,
                type: type,
                min_transfer_amount: min_transfer_amount,
            },
        });
        return response;
    } catch (error) {
        console.error("Error post submit claims:", error);
        throw error;
    }
}

// ========================= get financial transaction ======================

export async function xpayconnection(sf_school_id, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const response = await axios.get(`${XPAY_API_URL}/api/xpay-connections/`, {
            headers: {
                Authorization: `Bearer ${TOKEN_XSCHOOLPAY}`,
            },
            params: {
                sf_school_id: sf_school_id,
            },
        });
        return response.data; // Return the data directly
    } catch (error) {
        console.error("Error fetching xpay connection data:", error);
        throw error; // Re-throw the error to handle it outside this function
    }
}

// ========================= get financial transferts ======================

export async function getTransfers(xpay_connection_id, start_date, end_date, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const response = await axios.get(`${XPAY_API_URL}/api/transfers/`, {
            headers: {
                Authorization: `Bearer ${TOKEN_XSCHOOLPAY}`,
            },
            params: {
                xpay_connection_id: xpay_connection_id,
                start_date: start_date,
                end_date: end_date,
            },
        });
        return response.data; // Return the data directly
    } catch (error) {
        console.error("Error fetching transfers data:", error);
        throw error; // Re-throw the error to handle it outside this function
    }
}

// ========================= Post minimum transferts ======================

// ========================= Get parents number on eska ======================

export async function getParentsnumber(school_id) {
    try {
        const response = await axios.get(
            `${TOKEN_ESKA_API_URL}/scolarfleet/get_school_stats_on_eska/`,
            {
                headers: {
                    Authorization: `Bearer ${TOKEN_ESKA}`,
                },
                params: {
                    school_id: school_id,
                },
            }
        );
        return response.data; // Return the data directly
    } catch (error) {
        console.error("Error fetching parents number data:", error);
        throw error; // Re-throw the error to handle it outside this function
    }
}

// ========================= Note available  ======================

export async function postNoteAvailable(data, isAuthenticated=true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.post(
            `${REST_ENDPOINT}/api/send_alert_to_parent`,
            {
                school_id: data.school_id,
                code: data.code,
                registration_number_list: data.registration_number_list,
                subject_list: data.subject_list,
                reason_list: data.reason_list,
                attendance: data.attendance,
                punctuality: data.punctuality,
                attitude: data.attitude,
                engagement: data.engagement,
            },
            {
                params: {
                    session: data.sequence,
                    council_date: data.council_date,
                    council_time: data.council_time,
                    number_of_hours: data.number_of_hours,
                    absence_period: data.absence_period,
                    date: data.date,
                    suspension_reason: data.suspension_reason,
                    start_date: data.start_date,
                    end_date: data.end_date,
                },
            }
        );

        return {
            status: res.status,
            data: res.data,
        };
    } catch (error) {
        console.error("Error sending note availability alert:", error);
        return {
            status: error.response?.status || 500,
            error: error.response?.data || "Error sending alert",
        };
    }
}

// ========================= Subject list  ======================

export async function getSubjects(country_code, education_grade, training_type, education_system) {
    try {
        const response = await axios.get(`${TOKEN_ESKA_API_URL}/subjects/`, {
            headers: {
                Authorization: `Bearer ${TOKEN_ESKA}`,
            },
            params: {
                country_code: country_code,
                education_grade: education_grade,
                education_system: education_system,
                training_type: training_type,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching subjects:", error);
        throw error; // Re-throw the error to handle it outside this function
    }
}

// ========================= check number on eska ======================

export async function getchecknumberEska(data, isAuthenticated=true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios.post(`${REST_ENDPOINT}/api/check_numbers_on_eska`, {
            number_list: data["number_list"],
        });
        response = res.data;
    } catch (error) {
        response.status = error.response ? error.response.status : 500;
        response.error = error.response
            ? error.response.data
            : "Internal Server Error";
    }
    return response;
}

// ========================= check matricul on eska ======================
export async function getcheckmatriculEska(registration_number, isAuthenticated=true){
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios.post(
            `${REST_ENDPOINT}/api/check_registration_number`,
            {registration_number}
        );
        response = res.data;
    } catch (error) {
        response.status = error.response ? error.response.status : 500;
        response.error = error.response
            ? error.response.data
            : "Internal Server Error";
    }
    return response;
}

// ========================= Promote students  ======================
export async function PromoteStudent(data, isAuthenticated=true) {

    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.post(
            `${REST_ENDPOINT}/api/handle_promotion_cycle`,
            {
                action: data.action,
                current_classroom_id: data.current_classroom_id,
                new_classroom_id: data.new_classroom_id,
                registration_number_list: data.registration_number_list,
            },
        );

        if (res.status === 200) {
            return res.data;
        }
    } catch (err) {
        console.error("Erreur lors de la promotion des élèves:", err);
        throw err;
    }
}


// ========================= Send message  ======================

export async function sendmessage(data, isAuthenticated=true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.post(
            `${REST_ENDPOINT}/api/send_messages`,
            {
                target: data.target,
                grade: data.grade,
                classroom_number: data.classroom_number,
                body: data.body,
                media_url: data.media_url,
                registration_number_list: data.registration_number_list,
            },
        );

        if (res.status === 200) {
            return res.data;
        }
    } catch (err) {
        console.error("Erreur lors de l'envoi des notifications:", err);
        throw err;
    }
}

// ========================= Promote  ======================

export async function ActivePromote( isAuthenticated=true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.post(
            `${REST_ENDPOINT}/api/activate_promote_mode`,
        );
        if (res.status === 200) {
            return res.data;
        }
    } catch (err) {
        console.error("Erreur lors de l'activation de la promtion des élèves", err);
        throw err;
    }
}

export async function getAlertMessages( isAuthenticated=true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.get(
            `${REST_ENDPOINT}/api/send_alert_to_parent/`,
            
        );

        if (res.status === 200) {
            return res.data;
        }
    } catch (err) {
        console.error("Error getting alert messages:", err);
        throw err;
    }
}

// ========================= Post other installment ======================

export async function createotherconfig(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/other-payments/",
            method: "POST",
            data: data,
        });
        console.log(res);

        response.status = res.status;
        response.data = res.data;

        return response;
    } catch (err) {
        if (err.response) {
            response.status = err.response.status;
            response.error = err.response.data;
            console.error("Caught an error during creation other payment:", err);
        } else if (err.request) {
            console.error("Network error during creation other payment:", err);
        } else {
            console.error("Unexpected error during creation other payment:", err);
        }

        return response;
    }
}

// ==============Get other installment =====================

export async function getotherconfig(isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const response = await axios.get(`${REST_ENDPOINT}/api/other-payments/`);
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        return {
            status: error.response ? error.response.status : 500,
            error: error.response ? error.response.data : "Internal Server Error",
        };
    }
}

// ==============Delete other installment =====================

export async function deleteotherconfig(otherconfigId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/other-payments/${otherconfigId}`,
            method: "DELETE",
        });

        if (res.status === 204) {
            return true;
        }
    } catch (err) {
        console.error("Caught an error during DELETE other payment:", err);
        throw err;
    }
}

// ==============Update other installment =====================

export async function updateotherpayment(otherconfigId, data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + `/api/other-payments/${otherconfigId}`,
            method: "PUT",
            data: data,
        });
        console.log(res);

        response.status = res.status;
        response.data = res.data;

        return response;
    } catch (err) {
        if (err.response) {
            response.status = err.response.status;
            response.error = err.response.data;
            console.error("Caught an error during update of configuration:", err);
        } else if (err.request) {
            console.error("Network error during update of configuration:", err);
        } else {
            console.error("Unexpected error during update of configuration:", err);
        }

        return response;
    }
}

//============ get config by id  =======================

export async function getPayment(otherconfigId, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const response = await axios.get(
            REST_ENDPOINT + `/api/other-payments/${otherconfigId}`
        );
        return response;
    } catch (error) {
        console.error("Error fetching payment data:", error);
        throw error;
    }
}

// ==============Get registernumber  =====================

export async function getregisternumber( isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response = {};
    try {
        let res = await axios.get(`${REST_ENDPOINT}/api/get_registration_number`);
        response = res.data;
    } catch (error) {
        response.status = error.response ? error.response.status : 500;
        response.error = error.response
            ? error.response.data
            : "Internal Server Error";
    }
    return response;
}

// ==============Get registration number list =====================

export async function getRegisterNumbersList(count, isAuthenticated = true) {
  if (isAuthenticated) {
    const token = localStorage.getItem("authToken");
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
  let response = {};
  try {
    let res = await axios.get(
      `${REST_ENDPOINT}/api/get_registration_number`,
      {
        params: { count } // Registration number count
      }
    );
    response = res.data;
  } catch (error) {
    response.status = error.response ? error.response.status : 500;
    response.error = error.response
      ? error.response.data
      : "Internal Server Error";
  }

  return response;
}

export async function Campaigns({en_title, fr_title, en_body, fr_body, media, criteria}) {
    let response = {};
    try {
        let res = await axios.post(`${REST_ENDPOINT}/api/campaigns/`,
            {en_title, fr_title, en_body, fr_body, media, criteria,
        });
        response = res.data;
    } catch (error) {
        response.status = error.response ? error.response.status : 500;
        response.error = error.response
            ? error.response.data
            : "Internal Server Error";
    }
    return response;
}

export async function getCampaigns() {
    try {
        const res = await axios.get(`${REST_ENDPOINT}/api/campaigns/`);
        return res.data;
    } catch (error) {
        console.error("Error fetching campaigns:", error);
        return [];
    }
}

// ==============Get Xpay connection_detail =====================

export async function getxpconnection(connection_id) {
    try {
        const response = await axios.get(
            `${XPAY_API_URL}/api/xpay-connections/${connection_id}`,
            {
                headers: {
                    Authorization: `Bearer ${TOKEN_XSCHOOLPAY}`,
                },
            }
        );
        return response.data; // Return the data directly
    } catch (error) {
        console.error("Error fetching detail xp_connection data:", error);
        throw error; // Re-throw the error to handle it outside this function
    }
}

export async function nopay(data) {
    let student = {};
    try {
        let res = await axios({
            url: REST_ENDPOINT + "/api/get_xpay_connection",
            method: "POST",
            data: data,
        });
        if (res.status === 201) {
            student.status = res.status;
            student.data = res.data;
        }
        if (status.code === 400) {
            student.status = res.status;
            student.data = res.data;
        }
    } catch (err) {
        student = err.response;
        console.error("Caught an error during create student:", err);
    }
    return student;
}

// ==============Post receipt verified =====================

export async function postreceiptverified(data) {
    let response = {};
    try {
        let res = await axios.post(`${REST_ENDPOINT}/api/notify_receipt_verified`, {
            payment_id: data.payment_id,
            verification_status: data.verification_status,
            message: data.message,
        });
        response = res.data;
    } catch (error) {
        response.status = error.response ? error.response.status : 500;
        response.error = error.response
            ? error.response.data
            : "Internal Server Error";
    }
    return response;
}

// ===================== get notifiactions ========================

export async function getnotifications() {
    let response;
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/notifications/`,
            method: "GET",
        });

        if (res.status === 200) {
            response = res.data;
            //console.log("Réponse de notifications:", response);
        }
    } catch (err) {
        response = err.response;
        console.error("Erreur lors de l'appel de notifications:", err);
    }
    return response;
}

//============ School certificate config ===========================
// Configuration du certificat de scolarité, enregistrée côté serveur pour
// qu'une école n'ait pas à la refaire depuis un autre poste.

/**
 * Normalise une réponse d'API vers un objet unique (ou null).
 *
 * Selon l'implémentation, l'API peut renvoyer l'objet directement, une
 * liste, ou une enveloppe paginée — y compris sur les réponses de POST/PATCH,
 * pas seulement sur le GET. Sans cette normalisation partagée,
 * `extractConfigId` cherchait `data.id` sur une liste ou une enveloppe et ne
 * le trouvait jamais : la mise à jour suivante retombait alors sur l'URL de
 * collection au lieu de `/{id}/`, et n'appliquait aucun changement côté
 * serveur.
 */
function normalizeCertificateConfigResponse(data) {
    if (!data) return null;
    if (Array.isArray(data)) return data.length ? data[0] : null;
    if (Array.isArray(data.results)) return data.results.length ? data.results[0] : null;
    if (Array.isArray(data.objects)) return data.objects.length ? data.objects[0] : null;
    return Object.keys(data).length ? data : null;
}

/** Récupère la configuration enregistrée. Renvoie null si aucune n'existe. */
export async function getSchoolCertificateConfig(isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.get(`${REST_ENDPOINT}/api/school-certificate-config/`);
        if (res.status === 200) {
            return normalizeCertificateConfigResponse(res.data);
        }
        return null;
    } catch (err) {
        // 404 = aucune configuration enregistrée : ce n'est pas une erreur,
        // c'est simplement une école qui n'a pas encore configuré.
        if (err.response && err.response.status === 404) return null;
        console.error("Caught an error during GET school certificate config:", err);
        throw err;
    }
}

/** Crée la configuration du certificat. */
export async function createSchoolCertificateConfig(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.post(`${REST_ENDPOINT}/api/school-certificate-config/`, data);
        if (res.status === 200 || res.status === 201) {
            return normalizeCertificateConfigResponse(res.data);
        }
    } catch (err) {
        console.error("Caught an error during POST school certificate config:", err);
        throw err;
    }
}

/** Met à jour une configuration existante. */
export async function updateSchoolCertificateConfig(configId, data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        // L'identifiant n'est pas toujours renvoyé par l'API : sans lui on
        // retombe sur l'URL de collection, que le backend traite comme un
        // upsert pour la ressource unique de l'école.
        const url = configId
            ? `${REST_ENDPOINT}/api/school-certificate-config/${configId}/`
            : `${REST_ENDPOINT}/api/school-certificate-config/`;
        const res = await axios.patch(url, data);
        if (res.status === 200 || res.status === 201) {
            return normalizeCertificateConfigResponse(res.data);
        }
    } catch (err) {
        console.error("Caught an error during PATCH school certificate config:", err);
        throw err;
    }
}

//============ School payment receipt config =======================
// Configuration du modèle de reçu de paiement, enregistrée côté serveur pour
// qu'une école n'ait pas à la refaire depuis un autre poste.
//
// Même contrat que la configuration du certificat : ressource unique par
// établissement, l'URL de collection servant d'upsert quand l'API ne renvoie
// pas d'identifiant.

/** Récupère la configuration enregistrée. Renvoie null si aucune n'existe. */
export async function getSchoolReceiptConfig(isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.get(`${REST_ENDPOINT}/api/school-receipt-config/`);
        if (res.status === 200) {
            return normalizeCertificateConfigResponse(res.data);
        }
        return null;
    } catch (err) {
        // 404 = aucune configuration enregistrée : ce n'est pas une erreur,
        // c'est simplement une école qui n'a pas encore configuré.
        if (err.response && err.response.status === 404) return null;
        console.error("Caught an error during GET school receipt config:", err);
        throw err;
    }
}

/** Crée la configuration du reçu de paiement. */
export async function createSchoolReceiptConfig(data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios.post(`${REST_ENDPOINT}/api/school-receipt-config/`, data);
        if (res.status === 200 || res.status === 201) {
            return normalizeCertificateConfigResponse(res.data);
        }
    } catch (err) {
        console.error("Caught an error during POST school receipt config:", err);
        throw err;
    }
}

/** Met à jour une configuration existante. */
export async function updateSchoolReceiptConfig(configId, data, isAuthenticated = true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        // L'identifiant n'est pas toujours renvoyé par l'API : sans lui on
        // retombe sur l'URL de collection, que le backend traite comme un
        // upsert pour la ressource unique de l'école.
        const url = configId
            ? `${REST_ENDPOINT}/api/school-receipt-config/${configId}/`
            : `${REST_ENDPOINT}/api/school-receipt-config/`;
        const res = await axios.patch(url, data);
        if (res.status === 200 || res.status === 201) {
            return normalizeCertificateConfigResponse(res.data);
        }
    } catch (err) {
        console.error("Caught an error during PATCH school receipt config:", err);
        throw err;
    }
}
